import React, { useEffect, useState } from "react";
import "./Home.css";
import { getCookie } from "../Utils/Cookie";

function Home() {
  const [name, setName] = useState("");
  useEffect(() => {
    var kf = getCookie("kungfu");
    if (kf) setName(kf.fullname);
  }, []);
  return (
    <div className="content-container home-page">
      {name ? (
        <h1>Welcome, {name}!</h1>
      ) : (
        <h1>Welcome to EBM Kung Fu Academy</h1>
      )}
      <img src="/jingwu.jpg" className="right" alt="WU" />
      <p>
        The EBM Kung Fu Academy is a traditional Kung Fu school in Oakland
        California, USA. EBM provides authentic instruction in the Chinese
        martial arts of Northern Shaolin Kung Fu, San Shou (Sanda Chinese Kick
        Boxing), Xingyi Quan and Taiji Quan. EBM offers a complete program from
        traditional internal martial arts to state of the art full-contact Sanda
        competition. EBM Kung Fu has decades of experience with thousands of
        students in the arts and is home to the Oakland San Shou Team which has
        produced 6 National San Shou Kick Boxing Champions and holds over 30
        championship titles.
      </p>
    </div>
  );
}

export default Home;
